import withQueryDateState from './withQueryDateState'
import CustExchanger from './CustExchanger'

export default withQueryDateState(CustExchanger)
